import { Box } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { LoadingButton, NumberTextField } from "src/shared/components";
import { ISummaryReportItem } from "../model/types";

interface IUpdateRewardFormProps {
  handleSave: (values: {
    one_time_reward: number;
    active_accounts_quantity: number;
  }) => void;
  reward: ISummaryReportItem;
  isLoading?: boolean;
}
export function UpdateRewardForm({
  handleSave,
  isLoading,
  reward,
}: IUpdateRewardFormProps) {
  const { control, handleSubmit } = useForm({
    defaultValues: {
      active_accounts_quantity: reward.active_accounts_quantity,
      one_time_reward: reward.one_time_reward,
    },
  });

  return (
    <Box component="form" onSubmit={handleSubmit(handleSave)}>
      <Box
        onSubmit={handleSubmit(handleSave)}
        sx={{
          flexDirection: "column",
          display: "flex",
          p: 6,
          gap: 3,
        }}
      >
        <Controller
          control={control}
          name="active_accounts_quantity"
          render={({ field: { ref, ...field }, fieldState: { error } }) => (
            <NumberTextField
              fullWidth
              {...field}
              onChange={(v) => field.onChange(String(v))}
              inputRef={ref}
              label="Кол-во активных аккаунтов"
              error={!!error}
              helperText={error?.message}
            />
          )}
        />
        <Controller
          control={control}
          name="one_time_reward"
          render={({ field: { ref, ...field }, fieldState: { error } }) => (
            <NumberTextField
              fullWidth
              {...field}
              onChange={(v) => field.onChange(String(v))}
              inputRef={ref}
              label="Единовременное вознаграждение"
              error={!!error}
              helperText={error?.message}
              InputProps={{
                endAdornment: reward.complex_contract_currency
                  ? reward.complex_contract_currency
                  : "",
              }}
            />
          )}
        />
        <LoadingButton
          isLoading={isLoading}
          type="submit"
          variant="contained"
          color="primary"
        >
          Сохранить
        </LoadingButton>
      </Box>
    </Box>
  );
}
